import { useMemo } from 'react'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { calculateImbalance } from '../utils/imbalanceCalculator'
import './ImbalanceChart.css'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

function ImbalanceChart({ consumptionData }) {
  const { totalImbalance, dailyData } = useMemo(() => {
    return calculateImbalance(consumptionData)
  }, [consumptionData])

  if (!dailyData || dailyData.length === 0) return null

  const chartData = {
    labels: dailyData.map(d => d.date),
    datasets: [
      {
        label: 'Vienalaikis importas ir eksportas (kWh)',
        data: dailyData.map(d => d.imbalance),
        backgroundColor: 'rgba(234, 179, 8, 0.6)', // yellow-500
        borderColor: '#eab308',
        borderWidth: 1,
        borderRadius: 4,
      }
    ]
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            return `${context.dataset.label}: ${context.raw.toFixed(2)} kWh`
          }
        }
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Suvartojimas (kWh)',
          color: '#94a3b8'
        },
        grid: {
          color: 'rgba(71, 85, 105, 0.2)'
        },
        ticks: {
          color: '#94a3b8'
        }
      },
      x: {
        grid: {
          display: false
        },
        ticks: {
          color: '#94a3b8',
          maxRotation: 45,
          minRotation: 0
        }
      }
    }
  }

  return (
    <div className="imbalance-card">
      <div className="imbalance-header">
        <div className="header-icon">⚖️</div>
        <div className="header-text">
          <h3>Gamybos ir Vartojimo Disbalansas</h3>
          <p>
            Vienalaikis elektros importas ir eksportas tame pačiame 15 min. intervale. 
            Tai dažniausiai nutinka dėl vienfazės arba asimetrinės apkrovos, kai vienoje fazėje energiją vartojate, o kitoje atiduodate sugeneruotą (pvz., iš saulės elektrinės).
          </p>
        </div>
      </div>
      
      <div className="imbalance-stats">
        <div className="imbalance-stat-box">
          <div className="imbalance-stat-label">Bendra disbalanso energija</div>
          <div className="imbalance-stat-value">{totalImbalance.toFixed(2)} <span>kWh</span></div>
        </div>
        <div className="imbalance-stat-box explanation">
          <strong>Kodėl tai svarbu?</strong> Šią energiją atidavėte į tinklą ir iškart pasiėmėte atgal (fiziškai ji liko jūsų tinkle, bet apskaitoje buvo išskirta). Jei jums taikomas grynojo nuskaitymo (net-metering) modelis, už šį kiekį jūs vis tiek sumokėjote pasaugojimo/perdavimo mokesčius.
        </div>
      </div>

      <div className="chart-outer-container">
        <div className="chart-inner-container imbalance-chart">
          <Bar data={chartData} options={options} />
        </div>
      </div>
    </div>
  )
}

export default ImbalanceChart
